const mapPartnershipFormData = (data: any, pageTypeData: any) => {
  const forms: any = {};

  const {
    isCorporatePartnership,
    isWellnessCampaignPage,
    isOldUserReactivationPage,
    isVisaMastercardPartnership,
  } = pageTypeData;

  forms.showNameField = true;
  forms.showPhoneField = true;
  forms.acceptReferral = false;
  forms.showSelectPackage = true;
  forms.showGoalField = true;

  forms.namePlaceHolder = "Your Name";
  forms.mobilePlaceholder = "Your Phone";
  forms.emailPlaceholder = "Your Email";
  forms.companyNamePlaceholder = "Company Name";
  forms.goalPlaceholder = "Select condition";
  forms.selectedPackagePlaceholder = "What service are you looking for?";
  forms.promoCodePlaceholder = "Enter Promo Code";

  if (isCorporatePartnership) {
    forms.showEmailField = true;

    forms.showCompanyNameField = true;
    forms.emailPlaceholder = "Enter Official Email ID";
    forms.showSelectPackage = false;
    forms.showGoalField = false;
  }

  if (isWellnessCampaignPage) {
    forms.showEmailField = true;

    forms.acceptCoupon = true;
  }

  if (isOldUserReactivationPage) {
    forms.showEmailField = true;

    forms.goalPlaceholder = "Select condition/health goal";
  }

  if (isVisaMastercardPartnership) {
    forms.showEmailField = true;

    forms.showCompanyNameField = true;
  }

  if (isOldUserReactivationPage) {
    forms.services = data?.forms?.services?.map((item: any, index: number) => {
      return {
        ...item,
        slugs: data?.forms?.services[index].slugs?.filter((slugItem: any) => {
          let condition = ["strength-flexibility", "none"].includes(
            slugItem?.value
          );
          return !condition;
        }),
      };
    });
  }

  forms.isMainWebsitePage = data?.forms?.is_main_website_page;
  forms.defaultUrlArguments = data?.forms?.default_url_arguments;

  return forms;
};

const mapPartnershipPageTypeData = (data: any, pageSlug: string) => {
  const isCorporatePartnership = pageSlug.startsWith("corporate-partnership");
  const isWellnessCampaignPage = pageSlug === "wellness-campaign";
  const isOldUserReactivationPage = pageSlug === "allservices";
  const isVisaMastercardPartnership =
    data?.forms?.meta?.is_corporate_partnership_page &&
    pageSlug !== "corporate-partnerships";

  return {
    isCorporatePartnership,
    isWellnessCampaignPage,
    isOldUserReactivationPage,
    isVisaMastercardPartnership,
  };
};

export const mapPartnerBannerData = (response: any) => {
  const partnerDetail = response?.partner_detail || {};
  const data: any = {};

  data.partnerSrc = partnerDetail?.thumbnail;
  data.logoSize = {
    maxHeight: "82px",
    maxWidth: "233px",
    maxMobileHeight: "64px",
    maxMobileWidth: "207px",
  };
  data.locoSubtext = partnerDetail?.description;
  data.name = partnerDetail?.name;
  data.title = partnerDetail?.title;
  data.subtitle = partnerDetail?.subtitle;
  data.formLogo = partnerDetail?.reserve_image;

  return data;
};

const mapStaticGoalOptions = () => {
  return [
    { value: "health-for-pcos-india-49", label: "PCOS/D" },
    { value: "health-for-hypertension-india-49", label: "High BP" },
    { value: "health-for-thyroid-india-49", label: "Thyroid" },
    { value: "health-for-postnatal-india-49", label: "Post-natal" },
    { value: "health-for-prenatal-india-49", label: "Pre-natal" },
  ];
};

export const mapPartnershipProgramData = (data: any, pageSlug: string) => {
  const result: any = {};
  result.pageTypeData = mapPartnershipPageTypeData(data, pageSlug);
  result.forms = mapPartnershipFormData(data, result.pageTypeData);
  result.formattedData = mapPartnerBannerData(data);
  result.logoData = mapPartnerBannerData(data);
  result.staticGoalOptions = mapStaticGoalOptions();
  return result;
};
